function NotFound() {
  return (
    <main className="main max-w-xl grid gap-2 p-4 m-auto lg:mx-auto lg:my-0 z-0">
      <section className="w-full h-full">
        <img
          src="/assets/images/404.png"
          alt="404 Page Not Found"
          className="w-full h-full"
        />
      </section>
    </main>
  );
}

export { NotFound };
